export default {
	setCashBalance: ({ commit, rootGetters }, company, currency = 'GHS') => {
		if (_.isEmpty(company)) {
			company = rootGetters.company.external_client_id;
		}

		return axios
			.get(`/api/companies/${company}/balance`, {
				params: {
					type: 'cash-balance',
					currency
				}
			})
			.then(({ data: { data: { cash_balance } } }) => commit('setCashBalance', cash_balance));
	},
	setAccountShareBalance: ({ commit, rootGetters }, company, currency = 'GHS') => {
		if (_.isEmpty(company)) {
			company = rootGetters.company.external_client_id;
		}

		return axios
			.get(`/api/companies/${company}/balance`, {
				params: {
					type: 'account-share-balance',
					currency
				}
			})
			.then(({ data: { data: { cash_balance } } }) => commit('setAccountShareBalance', cash_balance));
	}
};
